import "./IconButton.css";

const DEFAULT_CLASSNAME = "icon-button";

const IconButton = ({ iconClassName, className, onPress, text }) => {
  const classNames = className
    ? `${DEFAULT_CLASSNAME} ${className}`
    : DEFAULT_CLASSNAME;

  return (
    <button onClick={onPress} className={classNames}>
      <i
        className={`icon-button__icon ${iconClassName} ${text && "ur-mr-1"}`}
      />
      {text && <span className={"rubik__family"}>{text}</span>}
    </button>
  );
};

export default IconButton;
